import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TranslationInterceptor implements HttpInterceptor {
  private defaultLanguage = 'en';

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const userLang = localStorage.getItem('language') || this.defaultLanguage;

    const modifiedReq = req.clone({
      setHeaders: { 'Accept-Language': userLang },
    });

    return next.handle(modifiedReq);
  }
}
